module.exports = __webpack_public_path__ + "static/media/sort-numeric-up.fabd001b.svg";